import {environment} from '../../environments/environment';
import {getApiUrl} from './helpers';
import {readAppLogs} from '../services/app-log.service';


/**
 * send the stored logs from the current run to the api server
 * @param serial currently paired scanner's serial number
 * @param logs array of log entries
 */
export const sendLogs = async (
  serial: string,
  logs: any[],
  scannerStatus?: Record<any, any>,
  platform = 'unknown',
  connection = 'unknown',
  type = 'system'
) => {
  let designTag = environment.appDesignName;
  if (!designTag || designTag === '') {
    designTag = 'None entered';
  }
  if (!serial || serial === 'None entered') {
    if (scannerStatus && scannerStatus.serial) {
      serial = scannerStatus.serial;
    }
  }
  const url = `${getApiUrl()}/log/`;
  try {
    const r = await fetch(url,
      {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json; charset=UTF-8',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          serial,
          logs,
          designTag,
          scannerStatus,
          connectionType: connection,
          platform,
          collection: type
        })
      }
    ).catch(err => console.log(`${err}`));
    if (r && r.status === 200) {
      return true;
    }
    return false;
  } catch (err) {
    return false;
  }
};

export const sendLogsSystem = async (
  serial: string,
  logs: any[],
  scannerStatus?: Record<any, any>,
  platform = 'unknown',
  connection = 'unknown',
  type = 'system'
) => {
  let designTag = environment.appDesignName;
  if (!designTag || designTag === '') {
    designTag = 'None entered';
  }
  if (!serial || serial === 'None entered') {
    if (scannerStatus && scannerStatus.serial) {
      serial = scannerStatus.serial;
    }
  }
  const url = `${getApiUrl()}/log/`;
  try {
    const r = await fetch(url,
      {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json; charset=UTF-8',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          serial,
          logs,
          designTag,
          scannerStatus,
          connectionType: connection,
          platform,
          collection: type
        }),
        // @ts-ignore
        signal: AbortSignal.timeout(10000)
      }
    ).catch(err => console.log(`${err}`));
    if (r && r.status === 200) {
      return [];
    } else if (logs.length > 1000) {
      return [];
    }
    return logs;
  } catch (err) {
    if (logs.length > 1000) {
      return [];
    }
    return logs;
  }
};

export const getLogs = () => {
  return readAppLogs('system');
};
